export default "__VITE_ASSET__BOpbvW17__"